





















































import { mapActionsDvm, mapMutationsDvm } from '@/main/pages';
import { ERROR } from '@/main/store/actionTypes';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { editName, TABLE_DATA } from '@/main/store/listEditTypes';
import { DEFAULT_SANITIZER_OPTIONS, sanitize } from '@/main/utils/html-sanitizer';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { EventBus } from '@/main/eventBus';
import _ from 'lodash';

import { apiProvider } from '../api';
import { DMS_MODULE, NAME, KALKULACE_DRUH, SMLUVNI_PARTNER_TYP } from '../constants';
import { store } from '../store/edit';
import { types } from '../store/types';

export default PageModeMixin.extend({
	name: 'ZakazkaKalkulace',
	components: {
		PracovnikSelect: Pracovnik.components.Select,
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
	},
	props: {
		storeUri: { type: String, default: '' },
	},
	data() {
		return {
			kalkulaceSelectVisible: false,
			loadingKalkulace: false,
			allDisabledBusEvent: false,
		};
	},
	computed: {
		...genVuexComputeds(store),
		isAllDisabled(): boolean {
			return this.allDisabledBusEvent || this.isViewMode;
		},
		mutationsMappers(): Record<string, string> {
			return {
				nakladoveStredisko: `${this.storeUri}/${types.mutations.ZAKAZKA_KALKULACE_STREDNAKL_SELECT}`,
				pracovnik: `${this.storeUri}/${types.mutations.ZAKAZKA_KALKULACE_PRACOVNIK_SELECT}`,
			};
		},
		kalkulaceSelectButtons(): Record<string, any> {
			return {
				SELECT_KALKULACE: {
					icon: 'el-icon-plus',
					onClickAction: (e: any, cells: any) => this.kalkulaceSelected(e, cells),
					value: 'SELECT_KALKULACE',
				},
			};
		},
		selectedServiceName(): string | null {
			const selectedService: any = this.dropdownList.KalkulacePzn.find((sel: any) => sel.Value === this.KalkulacePzn);
			if (selectedService) {
				const name = selectedService.Label || selectedService.Text;
				return name.split(' ')[0];
			}
			return null;
		},
		sendButtonLabel(): string {
			return `${this.LocalizePopisostatni('cmdKalkulaceSend')} ${this.selectedServiceName}`;
		},
		findButtonLabel(): string {
			return `${this.LocalizePopisostatni('cmdKalkulaceFind')} ${this.selectedServiceName}`;
		},
		openButtonLabel(): string {
			return `${this.LocalizePopisostatni('cmdKalkulaceOpen')} ${this.selectedServiceName}`;
		},
		strednaklOznFilter(): object {
			return { ProvozovnaId: this.KalkProvozovnaId, disabledProvozovna: true };
		},
		existDetailKalkulace(): boolean {
			return !_.isEmpty(this.sanitizedKalkPreviewRtf);
		},
		sanitizedKalkPreviewRtf(): string {
			return this.KalkPreviewRtf
				? sanitize(this.KalkPreviewRtf, {
					...DEFAULT_SANITIZER_OPTIONS,
					allowedAttributes: {
						div: ['style'],
						p: ['style'],
						span: ['style'],
						td: ['style'],
					},
					allowedStyles: {
						'*': { color: [/^#(0x)?[0-9a-f]+$/i, /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/] },
					},
				})
				: '';
		},
		selectKalkulaceModalLabel(): string {
			return `${this.LocalizePopisostatni('pageKalk')} - ${this.LocalizePopisostatni('cmdVyber')}`;
		},
	},
	watch: {
		async KalkulacePzn(value) {
			if (value) {
				await this.getIsKalkulaceSentToRemote(Number(value));
			} else {
				this.displayCalcButtons = false;
				this.isKalkulaceSentToRemote = null;
			}
		},
	},
	created() {
		EventBus.$on('DisableAll', this.setDisableBusEvent);
	},
	mounted() {
		if (this.KalkulacePzn) {
			this.getIsKalkulaceSentToRemote(this.KalkulacePzn);
		}
	},
	beforeDestroy() {
		EventBus.$off('DisableAll', this.setDisableBusEvent);
	},
	methods: {
		...mapMutationsDvm(store.mutations),
		...mapActionsDvm(store.actions),
		setDisableBusEvent(val: boolean) {
			this.allDisabledBusEvent = val;
		},
		async copyCalculation(): Promise<void> {
			try {
				await navigator.clipboard.writeText(this.sanitizedKalkPreviewRtf);
			} catch {
				// fallback pro starší prohlížeče a IE
				const dummyInput = document.createElement('input') as HTMLInputElement;
				document.body.appendChild(dummyInput);
				dummyInput.value = this.sanitizedKalkPreviewRtf;
				dummyInput.select();
				document.execCommand('copy');
				document.body.removeChild(dummyInput);
			}
		},
		async getIsKalkulaceSentToRemote(kalkulacePzn: number): Promise<void> {
			if (kalkulacePzn === KALKULACE_DRUH.SILVER_DAT_BTAC) {
				this.displayCalcButtons = false;
				return;
			}
			try {
				this.loadingKalkulace = true;
				const filter = {
					zakazkaId: this.ZakazkaId!,
					kalkulacePzn,
				};
				const { data: isSent } = await apiProvider.isKalkulaceSentToRemote(filter);
				this.isKalkulaceSentToRemote = isSent;
				this.displayCalcButtons = true;
				this.calcButtonsDisabled = {
					Najit: false || this.allDisabledBusEvent,
					Odeslat: isSent || this.allDisabledBusEvent,
					Otevrit: !isSent,
					Prevzit: !isSent || this.allDisabledBusEvent,
					Vymaz: !this.existDetailKalkulace || this.allDisabledBusEvent,
					OdpisPp: !this.existDetailKalkulace || this.allDisabledBusEvent,
					OdpisJfnd: !this.existDetailKalkulace || this.allDisabledBusEvent,
				};
			} catch (err) {
				this.$store.dispatch(ERROR, { moduleKey: DMS_MODULE, stateKey: editName(NAME), err }, { root: true });
			} finally {
				this.loadingKalkulace = false;
			}
		},
		async getKalkulaceFromRemote(): Promise<void> {
			try {
				this.startLoading();
				const filter = { zakazkaId: this.ZakazkaId!, kalkulacePzn: this.KalkulacePzn! };
				const { data: hasRemoteCalculation } = await apiProvider.getKalkulaceFromRemote(filter);
				if (hasRemoteCalculation) {
					const { data: remoteCalculationHtml } = await apiProvider.getKalkulaceRtfAsHtml({ zakazkaId: this.ZakazkaId! });
					this.KalkPreviewRtf = remoteCalculationHtml;
					this.calcButtonsDisabled!.Vymaz = false;
					this.calcButtonsDisabled!.OdpisJfnd = false;
					this.calcButtonsDisabled!.OdpisPp = false;
				} else {
					this.showErrorNotification(this.LocalizeChyboveHlasky('NoFindRecord'));
				}
			} catch (err) {
				this.$store.dispatch(ERROR, { moduleKey: DMS_MODULE, stateKey: editName(NAME), err }, { root: true });
			} finally {
				this.endLoading();
			}
		},
		async deleteKalkulace(): Promise<void> {
			try {
				this.startLoading();
				const { data: isKalkulaceDeleted } = await apiProvider.deleteKalkulace({ zakazkaId: this.ZakazkaId! });
				if (isKalkulaceDeleted) {
					this.calcButtonsDisabled = {
						Najit: false,
						Odeslat: true,
						Otevrit: false,
						Prevzit: false,
						Vymaz: true,
						OdpisPp: true,
						OdpisJfnd: true,
					};
					this.KalkPreviewRtf = null;
				}
			} catch (err) {
				this.$store.dispatch(ERROR, { moduleKey: DMS_MODULE, stateKey: editName(NAME), err }, { root: true });
			} finally {
				this.endLoading();
			}
		},
		async odpisJfndKalkulace(): Promise<void> {
			try {
				this.startLoading();
				const postData = {
					zakazkaId: this.ZakazkaId!,
					pracovnikId: this.KalkPracovnikId!,
				};
				const { data: pocetOdepsanychNd } = await apiProvider.takeNdToKalkulace(postData);
				if (pocetOdepsanychNd) {
					this.calcButtonsDisabled!.OdpisJfnd = true;
					this.calcButtonsDisabled!.Odeslat = true;
					this.calcButtonsDisabled!.Najit = false;
					this.calcButtonsDisabled!.Otevrit = false;
					this.calcButtonsDisabled!.Prevzit = false;
				}
				const { data: remoteCalculationHtml } = await apiProvider.getKalkulaceRtfAsHtml({ zakazkaId: this.ZakazkaId! });
				this.KalkPreviewRtf = remoteCalculationHtml;
			} catch (err) {
				this.$store.dispatch(ERROR, { moduleKey: DMS_MODULE, stateKey: editName(NAME), err }, { root: true });
			} finally {
				this.endLoading();
			}
		},
		async odpisPpKalkulace(): Promise<void> {
			try {
				this.startLoading();
				const postData = {
					zakazkaId: this.ZakazkaId!,
					pracovnikId: this.KalkPracovnikId!,
					provozovnaId: this.KalkProvozovnaId!,
					stredNaklOzn: this.KalkStredNaklOzn!,
					lakDruhId: this.LakdruhId!,
				};
				const { data: pocetOdepsanychPp } = await apiProvider.takePpToKalkulace(postData);
				if (pocetOdepsanychPp) {
					this.calcButtonsDisabled!.OdpisPp = true;
					this.calcButtonsDisabled!.Odeslat = true;
					this.calcButtonsDisabled!.Najit = false;
					this.calcButtonsDisabled!.Otevrit = false;
					this.calcButtonsDisabled!.Prevzit = false;
				}
				this.$store.dispatch(`${this.storeUri}/ZakazkaPracovniPozice_${TABLE_DATA}`);
				const { data: remoteCalculationHtml } = await apiProvider.getKalkulaceRtfAsHtml({ zakazkaId: this.ZakazkaId! });
				this.KalkPreviewRtf = remoteCalculationHtml;
			} catch (err) {
				this.$store.dispatch(ERROR, { moduleKey: DMS_MODULE, stateKey: editName(NAME), err }, { root: true });
			} finally {
				this.endLoading();
			}
		},
		async openKalkulaceSelect(): Promise<void> {
			try {
				this.startLoading();
				const filter = {
					zakazkaId: this.ZakazkaId!,
					kalkulacePzn: this.KalkulacePzn!,
				};
				const { data } = await apiProvider.getFindKalkulaceInRemoteSchemaAndRows(filter);
				this.setKalkulaceTableSchemaAndRows({ data });
				this.kalkulaceSelectVisible = true;
			} catch (err) {
				this.$store.dispatch(ERROR, { moduleKey: DMS_MODULE, stateKey: editName(NAME), err }, { root: true });
			} finally {
				this.endLoading();
			}
		},
		async kalkulaceSelected(e: any, cells: any): Promise<void> {
			const idColumnIndex = this.kalkulaceTable!.cellNames!.idColumn;
			try {
				this.startLoading();
				const postData = {
					zakazkaId: this.ZakazkaId!,
					kalkulacePzn: this.KalkulacePzn!,
					anotherId: `${cells[idColumnIndex]}`,
				};
				const { data: isKalkulaceAdded } = await apiProvider.addKalkulace(postData);
				if (isKalkulaceAdded) {
					this.calcButtonsDisabled!.OdpisPp = true;
					this.calcButtonsDisabled!.Odeslat = true;
					this.calcButtonsDisabled!.Najit = false;
					this.calcButtonsDisabled!.Otevrit = false;
					this.calcButtonsDisabled!.Prevzit = false;
				}
			} catch (err) {
				this.$store.dispatch(ERROR, { moduleKey: DMS_MODULE, stateKey: editName(NAME), err }, { root: true });
			} finally {
				this.kalkulaceSelectVisible = false;
				this.endLoading();
			}
		},
		async sendKalkulace(): Promise<void> {
			try {
				let confirmMessage = null;
				if (!this.LakdruhId && this.KalkulacePzn === KALKULACE_DRUH.AUDATEX) {
					confirmMessage = await this.LocalizeTextLong('BezLaku');
				} else if (this.KalkulacePzn === KALKULACE_DRUH.SILVER_DAT_CALCULATE_PRO && this.SmluvpartnerPzn === SMLUVNI_PARTNER_TYP.POJISTOVNA) {
					confirmMessage = this.LocalizeChyboveHlasky('PoistPripBezLaku');
				}
				if (confirmMessage) {
					const questionResult = await this.showConfirm({
						message: confirmMessage,
						title: this.LocalizeChyboveHlasky('questionTitle'),
						options: {
							confirmButtonText: this.Localize('Ano'),
							cancelButtonText: this.Localize('Ne'),
						},
					});
					if (!questionResult) {
						return;
					}
				}
				this.startLoading();
				await apiProvider.sendKalkulace({ ZakazkaId: this.ZakazkaId!, KalkulacePzn: this.KalkulacePzn! });
				this.calcButtonsDisabled!.Odeslat = true;
				this.calcButtonsDisabled!.Otevrit = false;
				this.calcButtonsDisabled!.Prevzit = false;
				this.isKalkulaceSentToRemote = true;
			} catch (err) {
				this.$store.dispatch(ERROR, { moduleKey: DMS_MODULE, stateKey: editName(NAME), err }, { root: true });
			} finally {
				this.endLoading();
			}
		},
		async openKalkulace(): Promise<void> {
			try {
				this.startLoading();
				const { data: url } = await apiProvider.getTaskUrlForOpen({ ZakazkaId: this.ZakazkaId!, KalkulacePzn: this.KalkulacePzn! });
				window.open(url, '_blank');
			} catch (err) {
				this.$store.dispatch(ERROR, { moduleKey: DMS_MODULE, stateKey: editName(NAME), err }, { root: true });
			} finally {
				this.endLoading();
			}
		},
	},
});
